<adapt-dialog [maxWidth]="1000">
    <h3 adapt-dialog-title>{{ title }}</h3>

    <div adapt-dialog-content>
        <div class="career-valuation display-career-valuation">
            <!-- overall -->
            <div class="card">
                <div class="card-header">
                    <h2 class="card-title">Overall</h2>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-lg-5">
                            <span class="career-valuation-total">{{ actualTotal }}%</span>
                            @if (careerValuation.notes) {
                                <div [froalaView]="careerValuation.notes"></div>
                            }
                            @if (filteredLinks.length) {
                                <div class="mt-3">
                                    <label>Associated actions</label>
                                    @for (link of careerValuation.links; track link) {
                                        <adapt-display-action-link [link]="link"
                                                                   [itemLinksDisabled]="true"
                                                                   [closeAllDialogsOnDelete]="false"> </adapt-display-action-link>
                                    }
                                </div>
                            }
                        </div>
                        <div class="d-none d-md-block d-print-block col-lg-7">
                            <dx-pie-chart #pieChart
                                          class="career-valuation-ideals-chart"
                                          [pathModified]="true"
                                          [dataSource]="idealsChartData"
                                          title="Ideal Ratings"
                                          [palette]="CareerValuetionPalette">
                                <dxo-pie-chart-legend [visible]="false"> </dxo-pie-chart-legend>
                                <dxi-pie-chart-series type="doughnut"
                                                      argumentField="argument"
                                                      valueField="value">
                                    <dxo-pie-chart-label [visible]="true"
                                                         [customizeText]="customiseLabelText">
                                        <dxo-pie-chart-connector [visible]="true"
                                                                 [width]="1"> </dxo-pie-chart-connector>
                                    </dxo-pie-chart-label>
                                </dxi-pie-chart-series>
                            </dx-pie-chart>
                        </div>
                    </div>
                </div>
            </div>

            <!-- each category -->
            @for (categoryValue of careerValuation.categoryValues; track categoryValue) {
                <div class="card career-valuation-category"
                     [class]="getCategoryHeadingClass(categoryValue)">
                    <adapt-cvt-category-value [categoryValue]="categoryValue"></adapt-cvt-category-value>
                </div>
            }

            <adapt-cultural-measurement-meta [culturalEntity]="careerValuation"
                                             [showCulturalLeaderData]="true"> </adapt-cultural-measurement-meta>
        </div>
    </div>

    <div adapt-dialog-footer
         class="ms-auto">
        @if (hasEditPermission) {
            <button adaptButton="edit"
                    [adaptBlockingClick]="editCareerValuation"></button>
        }
        @if (hasEditPermission) {
            <button adaptButton="delete"
                    (click)="deleteCareerValuation()"></button>
        }
        <button class="btn btn-primary"
                adaptButtonIcon="fa"
                (click)="closeDialog()">OK</button>
    </div>
</adapt-dialog>
